export default __webpack_public_path__ + "images/1c7c2677071e811d4aca7f0b4a48fbb3.svg";